<template>
  <div class="question question--multiple">
    <p class="question__q">
      {{q}}
      <span class="question__note" v-if="note">{{ note }}</span>
      <span class="question__source" v-if="source">{{ source }}</span>
    </p>
    <div class="question__answers">
      <div
        class="question__answer"
        v-for="(answer, index) in answers"
        :key="index"
        @click="updateAnswers(index)"
      >
        <span
          class="question__answer-radio"
          :class="{'active': currentActiveAnswers.includes(index), 'isCorrect': answer.correct && !isEditable, 'showResult': !isEditable}"
        ></span>
        <span class="question__answer-value">{{ answer.val }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleQuestion",
  data() {
    return {
      isEditable: true,
      currentActiveAnswers: [],
      maxAnswers: 1
    };
  },
  props: {
    answers: {
      type: Array,
      required: true
    },
    q: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    note: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: ""
    }
  },
  computed: {
    allAnswersCorrect() {
      const correctAnswers = this.currentActiveAnswers.map(
        answerIndex => this.answers[answerIndex].correct
      );
      return correctAnswers.filter(answer => answer).length === this.maxAnswers;
    }
  },
  mounted() {
    this.maxAnswers = this.answers.filter(answer => answer.correct).length;
  },
  methods: {
    updateAnswers(index) {
      if (!this.isEditable) return null;
      if (!this.currentActiveAnswers.includes(index)) {
        this.currentActiveAnswers.push(index);
      }
      if (this.currentActiveAnswers.length > this.maxAnswers) {
        this.currentActiveAnswers.splice(0, 1);
      }
      if (this.currentActiveAnswers.length == 2) this.isEditable = false;
      this.$emit("updateAnswer", {
        value: this.allAnswersCorrect,
        index: this.index
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.question {
  text-align: left;
  margin-top: 35px;

  &__q {
    margin-bottom: 20px;
  }

  &__answers {
    display: block;
    margin: 0 42px;
  }

  &__answer {
    display: block;
    line-height: 1.5rem;
    text-align: left;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    &-indicator {
      display: block;
      font-size: 0.875rem;
      font-weight: 700;
      margin-bottom: 6px;
    }
    &-value {
      color: $dove-gray;
      font-size: 0.8125rem;
    }
    &-radio {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 1px solid $eminence;
      border-radius: 50%;
      margin-right: 20px;
      vertical-align: middle;
      position: relative;

      &:before {
        background-color: $eminence;
        border-radius: 50%;
        content: "";
        width: 10px;
        height: 10px;
        display: block;
        position: absolute;
        top: 3px;
        left: 3px;
        opacity: 0;
        transition: all 0.4s ease-in-out;
      }

      &.active:before {
        opacity: 1;
      }

      &.active.showResult:before {
        background-color: #ee2e5d;
        opacity: 1;
      }

      &.isCorrect.showResult:before {
        background-color: #81C747;
        opacity: 1;
      }
    }
  }

  &__note {
    display: block;
    color: $black;
    font-size: 0.8125rem;
    line-height: 1.5rem;
  }

  &__source {
    color: $dove-gray;
    display: block;
    font-size: 0.5rem;
    line-height: 1.5rem;
  }
}
</style>